const LOCALE_MAP = { fr: 'fr-FR', en: 'en-US' };

export function formatDate(date, lang, options = { day: 'numeric', month: 'long', year: 'numeric' }) {
  if (!date) return '';
  return new Date(date).toLocaleDateString(LOCALE_MAP[lang] || 'fr-FR', options);
}

export function formatTime(date, lang, options = { hour: '2-digit', minute: '2-digit' }) {
  if (!date) return '';
  return new Date(date).toLocaleTimeString(LOCALE_MAP[lang] || 'fr-FR', options);
}
